/* global console, define */
define('casino/love',['jquery', 'all/player/session', 'all/dialog', 'all/slidingContentWrapper'], function($, session, dialog, slidingContentWrapper) {
	'use strict';

	var ACTIVE = 'active';
	var sendLoveTimestamp;

	function setupStartPage() {
		addClickHandlersOnCasinoStartPage();
		addSendClickHandlers();
	}

	function addClickHandlersOnCasinoStartPage() {
		var $loveHolder = $('.loved-games').find('ul');
		$.each($loveHolder.find('li'), function() {
			$(this).on('click', function() {
				var $loveTable = $('.loved-games').find('table');
				var $activeTab = $loveHolder.find('.active');
				$activeTab.removeClass('active');
				var activeTableIndex = $activeTab.parent().find('> li').index($activeTab);
				$loveTable.eq(activeTableIndex).hide();

				$(this).addClass('active');
				var thisTableIndex = $(this).parent().find('> li').index($(this));
				$loveTable.eq(thisTableIndex).show();
			});
		});
	}

	/**
	 * Click handler functions should be defined only once, but they may be
	 * attached as handlers for multiple elements.
	 * @param evt
	 */
	function loveClickHandler(evt) {
		var $this,
			gameId,
			isActive;

		if (session.authenticated) {
			$this = $(this);
			gameId = $this.data('game-id');
			isActive = $this.hasClass('active');

			send(gameId, !isActive);
		} else {
			slidingContentWrapper.showSlidingLoginPopup();
		}

	}
	function addSendClickHandlers() {
		$('.love-table').on('click', '.love', {}, loveClickHandler);
	}

	function ingame($gameHolder, game) {
		var gameId = game.id;
		$.ajax('/pp?flow=LoveJson&method=GET&gameId=' + gameId)
			.done(function(data) {
				var $love = $gameHolder.find('.love');
				$love.show();
				if (data.loved) {
					$love.addClass(ACTIVE);
				} else {
					$love.removeClass(ACTIVE);
				}
				$love.find('span').first().text(data.count);
				$love.unbind('click');
				$love.click(function() {
					sendLoveTimestamp = new Date().getTime() + 500;
					if (!session.authenticated) {
						slidingContentWrapper.showSlidingLoginPopup();
						return;
					}
					toggle($love);
					setTimeout(function() {
						if (sendLoveTimestamp > new Date().getTime()) {
							return;
						}
						send(gameId, $love.hasClass(ACTIVE));
					}, 500);
				});
			})
			.fail(function() {
				console.warn('Was not able to get the love count for ',  gameId);
			});
	}

	function toggle($love) {
		var $countSpan = $love.find('span').first();
		var loveCount = Number($countSpan.text());
		if ($love.hasClass(ACTIVE)) {
			if (loveCount >= 0) {
				$countSpan.text(loveCount - 1);
			}
			$love.removeClass(ACTIVE);
		} else {
			$countSpan.text(loveCount + 1);
			$love.addClass(ACTIVE);
		}
	}

	function send(gameId, isActive) {
		$.ajax('/pp?flow=LoveJson&method=UPDATE&gameId=' + gameId + '&isActive=' + isActive, { async: false })
			.done(function(data) {
				// Matches 0 or 1 anchors in each table (all-time, monthly, weekly)
				var $changedRows = $('.love-table').find('a[data-game-id="' + gameId + '"]');
				$.each($changedRows, function(index, value) {
					var $loveElement = $(value);
					if (isActive) {
						$loveElement.addClass('active');
					} else {
						$loveElement.removeClass('active');
					}
					// Update anchors with the new all time love count
					$loveElement.find('.all-time-count').text(data.count);
				});

				// Same count as above also exists in another place in the all-time table
				var $allTimeLoveTable = $('#all-time-love').find('tbody');
				$allTimeLoveTable.find('tr[data-game-id=' + gameId + '] td').eq(2).find('.count').text(data.count);

				// re-order and re-index the all-time table
				var $rows = $allTimeLoveTable.find('tr');
				$rows.sort(function(a, b) {
					return Number($('td', b).eq(2).find('.count').text()) - Number($('td', a).eq(2).find('.count').text());
				});
				$.each($rows, function(index) {
					$(this).find('td').first().text('#' + (index + 1));
				});
				$allTimeLoveTable.empty().append($rows);

			})
			.fail(function(data) {
				console.error('Failed to update love: ',  data);
			});
	}

    function populatePlayerLoveTable(playerLove){
        playerLove.forEach(function(gameId){
            var $changedRows = $('.love-table').find('a[data-game-id="' + gameId + '"]');
            $.each($changedRows, function() {
                $changedRows.addClass('active');
            });
        });
    }

    function populatePlayerLove(){
        $.ajax('/pp?flow=GetPlayerLoveGames')
            .done(function(data) {
                if(data.ERROR && data.ERROR.length > 0) {
                    console.log('Error fetching GetPlayerLoveGames:', data.ERROR, data);
                    clearPlayerLoveTable();
                } else {
                    populatePlayerLoveTable(data);
                }
            })
            .fail(function() {
                clearPlayerLoveTable();
            });
    }

    function clearPlayerLoveTable(){
        var $changedRows = $('.love-table').find('a');
        $.each($changedRows, function() {
            $changedRows.removeClass('active');
        });
    }

    function update() {
        if(session.authenticated){
            populatePlayerLove();
        }
        else{
            clearPlayerLoveTable();
        }
    }

    function onload(){
        $(session).on('login logout',update);
    }

	var love = {
		update: update,
        setupStartPage: setupStartPage,
		ingame: ingame
	};

    $(onload);

	return love;
});

